import { render } from "./Diagnostics.vue?vue&type=template&id=7798e621"
import script from "./Diagnostics.vue?vue&type=script&lang=ts"
export * from "./Diagnostics.vue?vue&type=script&lang=ts"
script.render = render

export default script